import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

/* Creating a slice of the state of the routing. */
const routingStateSlice = createSlice({
  name: 'routingState',
  initialState,
  reducers: {
    updateUrl: (state, action) => {
      const newUrl = action.payload;
      state.currentUrl = new URL(newUrl);
    },
    updatePagination: (state, action) => {
      state.urlPaging = action.payload;
    },
    updateBuilderName: (state, action) => {
      state.urlBuilderName = action.payload;
    },
    updateSubdirectory: (state, action) => {
      state.urlSubdirectory = action.payload;
    },
    updateLocation: (state, action) => {
      state.urlLocation = action.payload;
    },
    updateQueryString: (state, action) => {
      state.urlQueryString = action.payload;
    },
    updatePreviousPageUrl: (state, action) => {
      state.previousPageUrl = action.payload;
    },
    updateNextPageUrl: (state, action) => {
      state.nextPageUrl = action.payload;
    },
    updateRectangularSearchQueryString: (state, action) => {
      state.urlCoordinatesQueryString = action.payload;

      if (action.payload){
        state.urlLocation = 'map';
      }
    },
  },
});

export default routingStateSlice;
